import { AlertTriangle, Clock } from "lucide-react";

interface DeadlineBadgeProps {
  daysUntilDeadline: number | null;
}

export function DeadlineBadge({ daysUntilDeadline }: DeadlineBadgeProps) {
  if (daysUntilDeadline === null) {
    return null;
  }

  if (daysUntilDeadline <= 0) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
        <AlertTriangle className="h-3 w-3" />
        Vencido
      </span>
    );
  }

  if (daysUntilDeadline <= 2) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
        <AlertTriangle className="h-3 w-3" />
        {daysUntilDeadline}d
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
      <Clock className="h-3 w-3" />
      {daysUntilDeadline}d
    </span>
  );
}
